module.exports = __webpack_public_path__ + "media/images/about-us/works/Browse Courses_Updated-c2c3552134cc9a809336d0f41dcaae57.png";